// extracted by mini-css-extract-plugin
export default {"aside":"AsidePanel_aside__ftfHW","score":"AsidePanel_score__EH-V0","game-over":"AsidePanel_game-over__GD8M-"};